// Module dependencies
import router from 'app/common/lib/Router';

const HistoryNavigator = {
  /**
   * Handle navigating to a new URL.
   *
   * @param {string} url
   * @param {!NavigateData=} navigateData
   */
  navigate(url, navigateData) {
    router.instance.navigate(url, navigateData);
  },
};

export default HistoryNavigator;
